import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import { ToylandBannerImage } from 'JS/dxp/types/widgets/toyland-banner';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToylandInSeasonBanner',
  props: {
    toylandDeals: null
  },
  setup(__props: any) {

const props = __props as {
	toylandDeals: ToylandBannerImage[],
}




return { __sfc: true,props, BButton }
}

})